export default __webpack_public_path__ + "static/mission-rabies-5a017fa044e340922d7d9dc1e25d4c7f.jpg";